import React, { useState } from 'react';
import SellerDiscountBlock1 from '../SellerDiscountBlock1';
import SellerDiscountBlock2 from '../SellerDiscountBlock2';
import { ToastContainer } from 'react-toastify';

const DiscountPage = () => {
  const [currentBlock, setCurrentBlock] = useState('block1');

  const handleNavigate = (block) => {
    setCurrentBlock(block);
  };

  return (
    <div>
      <ToastContainer />
      {currentBlock === 'block1' && (
        <SellerDiscountBlock1 navigateTo={handleNavigate} />
      )}
      {currentBlock === 'block2' && (
        <SellerDiscountBlock2 navigateTo={handleNavigate} />
      )}
    </div>
  );
};

export default DiscountPage;
